var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMap(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.66787 0C5.80224 0 2.57812 3.1139 2.57812 7.08974C2.57812 8.60231 3.03264 9.95108 3.90494 11.2149L9.12531 19.3608C9.37856 19.7568 9.95769 19.7561 10.2104 19.3608L15.4534 11.1872C16.307 9.98064 16.7576 8.56385 16.7576 7.08974C16.7576 3.18046 13.5772 0 9.66787 0ZM9.66787 10.3124C7.89101 10.3124 6.44526 8.8666 6.44526 7.08974C6.44526 5.31288 7.89101 3.86713 9.66787 3.86713C11.4447 3.86713 12.8905 5.31288 12.8905 7.08974C12.8905 8.8666 11.4447 10.3124 9.66787 10.3124Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7064 14.8114L11.461 19.8854C10.6209 21.1951 8.71003 21.1908 7.874 19.8866L4.62329 14.8127C1.76315 15.474 0 16.6854 0 18.1331C0 20.6451 4.98121 22.0002 9.66783 22.0002C14.3544 22.0002 19.3357 20.6451 19.3357 18.1331C19.3357 16.6844 17.5701 15.4723 14.7064 14.8114Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMap);
export default __webpack_public_path__ + "static/media/map.b195493b68ee9f8253977cab820c566a.svg";
export { ForwardRef as ReactComponent };